<script setup lang="ts">
const props = defineProps<{
	data: {
		translation_key_label?: string
		label?: string
		to: string
		link?: boolean
		newTab?: boolean
		showOnlyOnPL?: boolean
		preLocalized?: boolean
	}[]
}>()

const i18nService = usei18nService()
const localePath = useLocalePath()
const { locale } = useI18n()
</script>

<template>
	<ul class="footer-links">
		<li v-for="item in props.data" :key="item.to">
			<a v-if="item?.link" class="footer-links__item" :href="item.to" target="_blank" rel="nofollow noopener">{{
				i18nService.$tDynamic('components.footer.links_and_app.links', item.translation_key_label || item.label)
			}}</a>
			<a
				v-else-if="item?.showOnlyOnPL ? locale === 'pl' : true"
				class="footer-links__item"
				:href="item.preLocalized ? item.to : localePath(item.to)">
				{{ i18nService.$tDynamic('components.footer.links_and_app.links', item.translation_key_label || item.label) }}
			</a>
		</li>
	</ul>
</template>

<style scoped lang="scss" src="./Links.scss"></style>
